import { usePlanIsNoAddressNeeded as useIsNoAddressNeeded } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-no-address-needed/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanIsNoAddressNeeded = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { isNoAddressNeeded } = viewModel;

	return useIsNoAddressNeeded({
		isNoAddressNeeded,
		onSetViewModel,
	});
};
